module.exports = __webpack_public_path__ + "static/media/Call.1c2b35d8.svg";